import { Pipe, PipeTransform } from '@angular/core';

import { campanhaStatuses } from '../campanha-status';

@Pipe({
    name: 'campanhaStatusIcon'
})
export class CampanhaStatusIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = campanhaStatuses.findIndex(status => status.id === value);
        if (index > -1) {
            return campanhaStatuses[index].icon;
        }
        return '';
    }
}
